export const  isCarwiser = process.env.REACT_APP_CARWISER_HOSTNAME.split('|').includes(window.location.hostname)